<template>
  <FormContainer>
    <template #title>Tuteur</template>
    <template #content>
      <div class="form__bloc">
        <BasicText
          weight="semibold"
          class="col-36"
          color="secondary-600"
        >
          Tuteur entreprise de travail temporaire
        </BasicText>
        <WrapperInput
          id="field_33"
          v-model="nomTuteurEtablissementModel"
          label="Nom"
          :required="meta.salarie?.tuteur?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.tuteur?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_34"
          v-model="prenomTuteurEtablissementModel"
          label="Prénom"
          :required="meta.salarie?.tuteur?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.tuteur?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_35"
          v-model="emploiOccupeTuteurEtablissementModel"
          label="Emploi occupé"
          :required="meta.salarie?.tuteur?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.tuteur?.emploiOccupe?.$messageErreurDirty!"
          hint="100 caractères max"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_EMPLOI_TUTEUR"
          :maxlength="100"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    PLACEHOLDER_EMPLOI_TUTEUR,
    PLACEHOLDER_PRENOM,
    PLACEHOLDER_NOM_NAIS,
    DEMANDE_STORE,
  } from '@/features/interface/demande/shared'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const nomTuteurEtablissementModel = setupFieldWithKey<string>('salarie.tuteur.nom', true)
  const prenomTuteurEtablissementModel = setupFieldWithKey<string>('salarie.tuteur.prenom', true)
  const emploiOccupeTuteurEtablissementModel = setupFieldWithKey<string>('salarie.tuteur.emploiOccupe')
</script>
